import { useEffect, useState } from "react";
import { publicApiClient } from "../../../api/apiClient";
import "./Calendar.css";

const FILE_BASE_URL = "https://api.dswustudent.kr";

const toAbsoluteUrl = (url) => {
  if (!url) return "";

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  if (url.startsWith("/")) {
    return `${FILE_BASE_URL}${url}`;
  }

  return `${FILE_BASE_URL}/${url}`;
};

const formatYearMonth = (year, month) => {
  return `${year}년 ${month + 1}월`;
};

export default function Calendar() {
  const today = new Date();

  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());

  const [calendarImage, setCalendarImage] = useState("");
  const [calendarLoading, setCalendarLoading] = useState(false);

  const fetchCalendarImage = async () => {
    try {
      setCalendarLoading(true);

      const result = await publicApiClient(
        `/api/activity/calendar/${year}/${month + 1}`,
        {
          method: "GET",
        }
      );

      console.log("달력 이미지 조회 성공:", result);

      const data = result?.data || result;
      const imageUrl = data?.imageUrl || "";

      setCalendarImage(toAbsoluteUrl(imageUrl));
    } catch (error) {
      console.error("달력 이미지 조회 실패:", error);
      setCalendarImage("");
    } finally {
      setCalendarLoading(false);
    }
  };

  useEffect(() => {
    fetchCalendarImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, month]);

  const prevMonth = () => {
    if (month === 0) {
      setYear((prev) => prev - 1);
      setMonth(11);
      return;
    }

    setMonth((prev) => prev - 1);
  };

  const nextMonth = () => {
    if (month === 11) {
      setYear((prev) => prev + 1);
      setMonth(0);
      return;
    }

    setMonth((prev) => prev + 1);
  };

  return (
    <div className="calendar-page">
      <div className="calendar-title-section">
        <h2 className="calendar-title">달력</h2>
      </div>

      <div className="calendar-nav">
        <button className="calendar-nav-btn" onClick={prevMonth} type="button">
          <svg
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="7 1 1 7 7 13" />
          </svg>
        </button>

        <span className="calendar-nav-label">
          {formatYearMonth(year, month)}
        </span>

        <button className="calendar-nav-btn" onClick={nextMonth} type="button">
          <svg
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="1 1 7 7 1 13" />
          </svg>
        </button>
      </div>

      <div className="calendar-image-wrap">
        {calendarLoading ? (
          <div className="calendar-image-empty">
            달력 이미지를 불러오는 중입니다.
          </div>
        ) : calendarImage ? (
          <img
            src={calendarImage}
            alt={`${formatYearMonth(year, month)} 달력`}
            className="calendar-image"
          />
        ) : (
          <div className="calendar-image-empty">
            등록된 달력 이미지가 없습니다.
          </div>
        )}
      </div>
    </div>
  );
}